import { render, staticRenderFns } from "./dtlMain.vue?vue&type=template&id=406b97a5&scoped=true"
import script from "./dtlMain.vue?vue&type=script&lang=js"
export * from "./dtlMain.vue?vue&type=script&lang=js"
import style0 from "./dtlMain.vue?vue&type=style&index=0&id=406b97a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b97a5",
  null
  
)

export default component.exports